// extracted by mini-css-extract-plugin
module.exports = {"root":"Content_root__EeA_2"};